import { useState } from "react";
import { deleteTraveller } from "../../Actions/TravellerAction";
import moment from "moment-jalaali";

const TravellerItem = (props) => {
    const { traveller, fillPassengerInformation, refetchTravellersData } = props;

    const [deleteLoading, setDeleteLoading] = useState(false);

    const deleteItem = async () => {
        setDeleteLoading(true);
        const response = await deleteTraveller(traveller.id);
        setDeleteLoading(false);
        if (response.data) {
            refetchTravellersData();
        }
    }

    return (
        <tr>
            <td> {traveller.firstname} {traveller.lastname} </td>
            <td> {traveller.gender ? "مذکر" : "مونث"} </td>
            <td> {traveller.nationalId || traveller.passportNumber} </td>
            {!props.isHotel && <td> {traveller.passportExpirationDate ? moment(traveller.passportExpirationDate).format("YYYY/MM/DD") : "--"} </td>}
            <td> {traveller.birthDate ? moment(traveller.birthDate).format("YYYY/MM/DD") : "--"} </td>
            <td>
                <button
                    type="button"
                    className="button blue-btn small-btn min-w-55"
                    onClick={() => { fillPassengerInformation(traveller) }}
                >
                    انتخاب
                </button>

                <button
                    type="button"
                    className="button red-btn small-btn min-w-55 margin-start-light"
                    onClick={deleteItem}
                >
                    {deleteLoading ? (
                        <span className="dots-loading"><span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></span>
                    ) : (
                        " حذف "
                    )}
                </button>
            </td>
        </tr>
    )
}

export default TravellerItem;